import React, { useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Input, Button, Descriptions, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// import {
//   changeTestRegisterLink,
//   updateCurrentTestBasicDetails,
//   changeTestRegisterStatus,
//   changeTestStatus,
//   updateCandidatesTest,
// } from "../../../actions/conductTest";

import {
  setTestRegisterLink,
  changeBeginTestStatus,
  changeCandidatesOfTest,
  changeIsRegistrationAvailable
} from "../../../reducers/conductTest";
import { updateCurrentTestBasicDetails } from "../../../features/trainerAsync";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import Alert from "../../common/alert";

const TestDetails = () => {
  const dispatch = useDispatch();
  const conduct = useSelector((state) => state.conductTest);
  //  console.log(conduct);
  

  const location = useLocation(); // not directly used, but for router v6 awareness

  useEffect(() => {
    const baseUrl = window.location.origin;
    const mainlink = `${baseUrl}/#/trainee/register?testid=${conduct.id}`;

    dispatch(setTestRegisterLink(mainlink));
    dispatch(updateCurrentTestBasicDetails(conduct.id));
    dispatch(changeCandidatesOfTest());
  }, []);

  const changeRegistrationStatus = (status) => {
    SecurePost({
      url: apis.STOP_REGISTRATION,
      data: {
        id: conduct.id,
        status,
      },
    })
      .then((response) => {
        // console.log("Response",response);
        
        if (response.data.success) {
          // console.log("Status",response.data);
          
          dispatch(changeIsRegistrationAvailable(response.data.currentStatus));
          Alert("success", "Success!", "Registration status changed");
        }
      })
      .catch((error) => {
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", errorMsg);
      });
  };

  const handleStartTest = () => {
    SecurePost({
      url: apis.START_TEST_BY_TRAINER,
      data: {
        id: conduct.id,
      },
    })
      .then((response) => {
        if (response.data.success) {
          dispatch(changeBeginTestStatus(response.data.data));
          Alert("success", "Success!", "Test has begun");
        } else {
          Alert("error", "Error!", response.data.message);
        }
      })
      .catch((error) => {
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", errorMsg);
      });
  };

  const handleEndTest = () => {
    SecurePost({
      url: apis.END_TEST_BY_TRAINER,
      data: {
        id: conduct.id,
      },
    })
      .then((response) => {
        if (response.data.success) {
          dispatch(changeBeginTestStatus(response.data.data));
          Alert("success", "Success!", "Test has ended");
        } else {
          Alert("error", "Error!", response.data.message);
        }
      })
      .catch((error) => {
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", errorMsg);
      });
  };

  return (
    <div>
      <Descriptions
        size="small"
        column={4}
        title="Basic Test Info"
        layout="vertical"
        bordered
      >
        <Descriptions.Item span={1} label="Test Id">
          {conduct.id}
        </Descriptions.Item>

        <Descriptions.Item span={3} label="Registration Link">
          <Input
            disabled
            value={conduct.testRegisterLink}
            addonAfter={
              <CopyToClipboard
                text={conduct.testRegisterLink}
                onCopy={() => message.success("Link Copied to clipboard")}
              >
                <CopyOutlined />
              </CopyToClipboard>
            }
          />
        </Descriptions.Item>

        <Descriptions.Item
          span={1}
          label={
            conduct.currentTestDetails?.isRegistrationavailable
              ? "Registration Open"
              : "Registration Closed"
          }
        >
          <Button
            onClick={() =>
              changeRegistrationStatus(
                !conduct.currentTestDetails?.isRegistrationavailable
              )
            }
            type={
              conduct.currentTestDetails?.isRegistrationavailable
                ? "primary"
                : "default"
            }
            // danger={conduct.currentTestDetails?.isRegistrationavailable}
          >
            {conduct.currentTestDetails?.isRegistrationavailable
              ? "Stop Registration"
              : "Open Registration"}
          </Button>
        </Descriptions.Item>

        {/* Uncomment if you want start/end test control */}
        <Descriptions.Item
          span={3}
          label={
            conduct.currentTestDetails?.testbegins
              ? "Test in Progress"
              : "Test has not started yet"
          }
        >
          <Button
            disabled={conduct.currentTestDetails?.testbegins}
            onClick={handleStartTest}
            type="primary"
          >
            Start Test
          </Button>
          <Button
            disabled={!conduct.currentTestDetails?.testbegins}
            onClick={handleEndTest}
            danger
            style={{marginLeft:20}}
          >
            End Test
          </Button>
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default TestDetails;
